export default __webpack_public_path__ + "img/gfx_industry_mixers-41173a879e2198d63f2691411dca0a6a.png";